<app-modal-container
  [title]="'Share'"
  [titleDirection]="'start'"
  [bigSize]="false"
  [buttons]="{ close: true }"
  [spinnerProps]="spinnerProps"
  (closeButtonClicked)="closeButtonClickedEmitter.emit()">
  <div class="flex flex-col items-start gap-y-[1rem] w-[34.75rem]">
    <app-team-table
      class="w-full"
      [isAbleToManageUsers]="currentEmployee.isAbleToManageUsers"
      [modalMode]="true"
      [employees]="employees"
      (deleteUser)="deleteUserEmitter.emit($event)"
      (updateIsAbleToManageUsers)="updateIsAbleToManageUsersEmitter.emit($event)"
      (resendInvite)="resendInviteEmitter.emit($event)"
    />
    <app-button
      data-qa="share-modal-add-member"
      [type]="'accent'"
      [size]="'small'"
      [showIcon]="'left'"
      [iconName]="'plus.svg'"
      (buttonClick)="openInviteMemberModalEmitter.emit()">
      Invite co-admin
    </app-button>
  </div>
</app-modal-container>
